// src/data/workbookCatalog.js
// ================================================================
// کاتالوگ مرکزی قیمت کتاب کارها — از پایه ۱ تا ۱۲
// ----------------------------------------------------------------
// • طرح bookId:
//     پایه ۱-۹:  {subject}-{grade}          مثل: riazi-1
//     پایه ۱۰-۱۲: {subject}-{grade}-{field} مثل: riazi-10-tajrobi
//
// • اولویت‌بندی قیمت:
//     ۱. BOOK_OVERRIDES[bookId]  (اختصاصی)
//     ۲. GRADE_PRICING[grade]    (پایه‌محور)
//     ۳. DEFAULT_PRICING         (پشتیبان)
// ================================================================

const DEFAULT_PRICING = {
  coinPrice: 500,
  tomanPrice: 50000,
  durationDays: 365,
};

// ── قیمت پایه به‌ازای هر پایه ──
// هر وقت خواستی تغییر بده، فقط این جدول را ویرایش کن
const GRADE_PRICING = {
  1:  { coinPrice: 300,  tomanPrice: 30000,  durationDays: 365 },
  2:  { coinPrice: 350,  tomanPrice: 35000,  durationDays: 365 },
  3:  { coinPrice: 400,  tomanPrice: 40000,  durationDays: 365 },
  4:  { coinPrice: 450,  tomanPrice: 45000,  durationDays: 365 },
  5:  { coinPrice: 500,  tomanPrice: 50000,  durationDays: 365 },
  6:  { coinPrice: 550,  tomanPrice: 55000,  durationDays: 365 },
  7:  { coinPrice: 600,  tomanPrice: 60000,  durationDays: 365 },
  8:  { coinPrice: 650,  tomanPrice: 65000,  durationDays: 365 },
  9:  { coinPrice: 700,  tomanPrice: 70000,  durationDays: 365 },
  10: { coinPrice: 800,  tomanPrice: 80000,  durationDays: 365 },
  11: { coinPrice: 900,  tomanPrice: 90000,  durationDays: 365 },
  12: { coinPrice: 1000, tomanPrice: 100000, durationDays: 365 },
};

// ── قیمت اختصاصی برای کتاب‌های خاص (اولویت بالاتر از جدول پایه) ──
const BOOK_OVERRIDES = {
  'riazi-9': { coinPrice: 1500, tomanPrice: 150000, durationDays: 365 },
  'riazi-1': { coinPrice: 0, tomanPrice: 150000, durationDays: 365 },
   //'riazi-12-riazi': { coinPrice: 1500, tomanPrice: 150000, durationDays: 365 },
  // 'zist-11-tajrobi': { coinPrice: 1200, tomanPrice: 120000, durationDays: 365 },
};

// ── استخراج grade از bookId ──
const parseBookId = (bookId) => {
  if (!bookId || typeof bookId !== 'string') return { grade: null };
  // آخرین عدد ۱-۱۲ در رشته
  const matches = bookId.match(/-(\d{1,2})(?:-|$)/g);
  if (!matches || matches.length === 0) return { grade: null };
  const last = matches[matches.length - 1].replace(/-/g, '');
  const grade = parseInt(last, 10);
  if (grade >= 1 && grade <= 12) return { grade };
  return { grade: null };
};

// ── API اصلی ──
export const getWorkbookPricing = (bookId) => {
  if (!bookId) return { ...DEFAULT_PRICING };

  // ۱. override اختصاصی
  if (BOOK_OVERRIDES[bookId]) {
    return { ...DEFAULT_PRICING, ...BOOK_OVERRIDES[bookId] };
  }

  // ۲. پایه‌محور
  const { grade } = parseBookId(bookId);
  if (grade && GRADE_PRICING[grade]) {
    return { ...GRADE_PRICING[grade] };
  }

  // ۳. پیش‌فرض
  return { ...DEFAULT_PRICING };
};

// ── اکسپورت‌های کمکی (برای دیباگ/UI) ──
export const getAllGradePricing = () => ({ ...GRADE_PRICING });
export const setBookOverride = (bookId, pricing) => {
  BOOK_OVERRIDES[bookId] = { ...pricing };
};

export { GRADE_PRICING, BOOK_OVERRIDES, DEFAULT_PRICING };
export default getWorkbookPricing;